import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { PartnerStrip } from "@/components/landing/PartnerStrip";
import { Manifesto } from "@/components/landing/Manifesto";
import { IncludedStack } from "@/components/landing/IncludedStack";
import { Timeline } from "@/components/landing/Timeline";
import { TeamStrip } from "@/components/landing/TeamStrip";
import { Guarantee } from "@/components/landing/Guarantee";
import { CaseStudies } from "@/components/landing/CaseStudies";
import { VideoCaseStudies } from "@/components/landing/VideoCaseStudies";
import { Testimonials } from "@/components/landing/Testimonials";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Booking } from "@/components/landing/Booking";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#F4F2EC] text-[#101010]">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <PartnerStrip />
        <Manifesto />
        <IncludedStack />
        <Timeline />
        <Guarantee />
        <TeamStrip />
        <CaseStudies />
        <VideoCaseStudies />
        <Testimonials />
        <EditorialMarquee />
        <Booking />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}

export default App;
